module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"field-optional":"Facultatif"},"en":{"field-optional":"Optional"}}')
  delete Component.options._Ctor
}
